import _slicedToArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _toConsumableArray from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es7.object.values.js";
import "core-js/modules/es7.object.entries.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
/* eslint-disable no-param-reassign */
import produce from 'immer';
var cellSetsDelete = produce(function (draft, action) {
  // A deleted cell class also takes all its cell sets with it
  var _action$payload = action.payload,
    key = _action$payload.key,
    _action$payload$cellS = _action$payload.cellSetKeys,
    cellSetKeys = _action$payload$cellS === void 0 ? [] : _action$payload$cellS;
  var deletedKeys = [key].concat(_toConsumableArray(cellSetKeys));
  Object.values(draft.comparison.group).forEach(function (comparisonGroup) {
    Object.entries(comparisonGroup).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        comparisonKey = _ref2[0],
        comparisonValue = _ref2[1];
      if (!deletedKeys.includes(comparisonValue)) return;
      comparisonGroup[comparisonKey] = null;
    });
  });
});
export default cellSetsDelete;